import { lock, shared, valuePrivate, valueShared } from "_constants";
import { PrimeIcons } from "primereact/api";

export const VisibilityChip = ({ type }: { type: "SHARED" | "PRIVATE" }) => {
  return (
    <div
      className={`container-visibility ${
        type === "SHARED" ? valueShared : valuePrivate
      }`}
    >
      <i className={type === "SHARED" ? PrimeIcons.CLOUD : PrimeIcons.LOCK}></i>
      <small className="small font-weight-600">
        {type === "SHARED" ? shared : lock}
      </small>
    </div>
  );
};
